import {ListGroup} from "@app/core/lists/domain/list-group";
import {List} from "@app/core/lists/domain/list";
import {ListMapper} from "@app/core/lists/infrastructure/mappers/list.mapper";


export class ListGroupMapper {
    static deserialize(param: any): ListGroup {
        return {
            id: param.id,
            name: param.name,
            lists: param.lists.map(ListMapper.deserialize).sort(
                (listGroupA: List, listGroupB: List) => {
                    if (listGroupA.id === listGroupB.id) {
                        return 0; //no sorting
                    }
                    return listGroupA.id < listGroupB.id ? -1 : 1 //sort string ascending
                })
        };
    }
}